import React from 'react';

export const Card =(props) => {
  return (
      <div className={'cardContainerStyle'}>
          {props.children}
      </div>
  );
};
